import { h } from 'preact';

import Filter from './components/Filter';

export default function ViewActiveFilters({
	activeFilters,
	onResetFilterHandler
}) {

	return (
		<div class="news-filter-active-filters-container">
			{activeFilters.length > 0 ? 'Actieve filters: ' : 'Geen filters actief.'}
			{activeFilters.map(filter => <Filter key={filter.name} {...filter} onResetFilterHandler={onResetFilterHandler} />)}
		</div>
	);

}
